export default {
    isRedisChange:(state:any):string => state.isRedisChange,
};
